import { render, staticRenderFns } from "./vue-tags-input.vue?vue&type=template&id=61d92e31&"
import script from "./vue-tags-input.js?vue&type=script&lang=js&"
export * from "./vue-tags-input.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/reddico/Documents/vue-tags-input/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('61d92e31', component.options)
    } else {
      api.reload('61d92e31', component.options)
    }
    module.hot.accept("./vue-tags-input.vue?vue&type=template&id=61d92e31&", function () {
      api.rerender('61d92e31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue-tags-input/vue-tags-input.vue"
export default component.exports